/* eslint-disable no-unused-expressions */
import { injectGlobal } from 'styled-components';

injectGlobal`
  html {
    height: 100vh;
    width: 100vw;
    font-size: 16px;
  }

  body {
    height: 100vh;
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    color: #19344C;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    padding: 0;
    margin: 0;
    text-align: center;
    font-smooth: antialiased;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: antialiased;
  }

  body.fontLoaded {
    font-family: 'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }
  
  body.horizontal {
    overflow-y: hidden;
    overflow-x: auto;
  }

  body.vertical {
    overflow-y: auto;
    overflow-x: hidden;
  }

  button {
    padding: 0;
    margin: 0;
  }

// TODO: better location ? can we use styled components
.intro-enter {
  opacity: 0.01;
}
.intro-enter-active {
  opacity: 1;
  transition: all 750ms ease-out;
}
.intro-exit {
  opacity: 1;
}
.intro-exit-active {
  opacity: 0.01;
  transition: all 750ms ease-out;
}

.hidelayer-enter {
  opacity: 0.21;
}
.hidelayer-enter-active {
  opacity: 1;
  transition: all 750ms ease-out;
}
.hidelayer-exit {
  opacity: 1;
}
.hidelayer-exit-active, .hidelayer-exit-done {
  opacity: 0.21;
  transition: all 750ms ease-out;
}
`;



// WEBPACK FOOTER //
// ./src/global-styles.js